import React from 'react'
import styles from './styles.module.scss'

const Badge = props => {
  return (
    <p aria-disabled style={props.style} className={styles.badge}>
      {props.text}
    </p>
  )
}

export default Badge
